"use client";

import React from "react";
import { GalleryContactUsItem, GalleryItem, GalleryRoot } from "./parts";
import GalleryFilterProvider from "./provider";
import type { GalleryProps } from "./types";

function GalleryWrapper({ children, ...props }: GalleryProps) {
  return (
    <GalleryFilterProvider>
      <GalleryRoot {...props}>{children}</GalleryRoot>
    </GalleryFilterProvider>
  );
}

const Gallery = Object.assign(GalleryWrapper, {
  Item: GalleryItem,
  ContactUsItem: GalleryContactUsItem,
});

export default Gallery;
